import { prependStaticClass, createClass } from './helpers'

export default {
  name: 'Column',
  functional: true,
  props: {
    element: {
      type: String,
      default: 'div'
    },
    size: {
      type: String,
      default: null
    },
    breakpoint: {
      type: String,
      default: null
    },
    offset: {
      type: String,
      default: null
    }
  },
  render: (createElement, context) => {
    const additionalClass = createClass('col', context.props.breakpoint, context.props.size)
    const additionalClasses = [additionalClass]
    // Offset isn't working as a result of custom bootstrap overrides, leaving this here as a TODO.
    // if (context.props.offset) additionalClasses.push(createClass('offset', context.props.breakpoint, context.props.size))
    context.data.staticClass = prependStaticClass(context, additionalClasses)
    return createElement(context.props.element, context.data, context.children)
  }
}
